export default __webpack_public_path__ + "static/media/assessment-map-active.9c17eb28.svg";